import { render, staticRenderFns } from "./ad-position.vue?vue&type=template&id=f770da06&scoped=true"
import script from "./ad-position.vue?vue&type=script&lang=js"
export * from "./ad-position.vue?vue&type=script&lang=js"
import style0 from "./ad-position.vue?vue&type=style&index=0&id=f770da06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f770da06",
  null
  
)

export default component.exports